import { Head, Link } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
export default {
  components: {
    Head: Head,
    Link: Link
  },
  layout: Layout
};